/***
 * File name: rolesTable.js
 *
 * Program Description:
 * List of user roles/privileges within the system
 *
 * Used for hiding action buttons and contents to unauthorized users
 *
 */
export default {
  entries: [
    {
      name: 'Login',
      value: 'login',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Log Out',
      value: 'logout',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Create User by User Role',
      value: 'createByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'View All Users',
      value: 'readUsers',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'View User by User Role',
      value: 'readUserByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Update User by User Role',
      value: 'updateUserByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Activate User by User Role',
      value: 'activateUserByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Deactivate User by User Role',
      value: 'deactivateUserByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Soft Delete User by User Role',
      value: 'softDeleteUserByUserRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Verify Email',
      value: 'verifyEmail',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Request Change of Password',
      value: 'requestChangePassword',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Change Password',
      value: 'changePassword',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Request Reset of Password',
      value: 'requestResetPassword',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Reset Password',
      value: 'resetPassword',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Forgot Password',
      value: 'forgotPassword',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'View Own Profile',
      value: 'viewOwnProfile',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Update Own Profile',
      value: 'updateOwnProfile',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'View All User Roles',
      value: 'viewAllRoles',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'View Role',
      value: 'viewRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Create User Role',
      value: 'createRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Update User Role',
      value: 'updateRole',
      module: 'Account Administration',
      default: false
    },
    {
      name: 'Delete User Role',
      value: 'deleteRole',
      module: 'Account Administration',
      default: false
    },
    // DBN Status
    {
      name: 'Create DBN Status',
      value: 'postDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All DBN Status',
      value: 'viewAllDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View DBN Status',
      value: 'viewDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update DBN Status',
      value: 'patchDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete DBN Status',
      value: 'deleteDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate DBN Status',
      value: 'activateDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate DBN Status',
      value: 'deactivateDbnStatus',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete DBN Status',
      value: 'softDeleteDbnStatus',
      module: 'Master Data',
      default: false
    },
    // Notification Type
    {
      name: 'Create Notification Type',
      value: 'postNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All Notification Type',
      value: 'viewAllNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View Notification Type',
      value: 'viewNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update Notification Type',
      value: 'patchNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete Notification Type',
      value: 'deleteNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate Notification Type',
      value: 'activateNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate Notification Type',
      value: 'deactivateNotificationType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete Notification Type',
      value: 'softDeleteNotificationType',
      module: 'Master Data',
      default: false
    },
    // Nature of Breach
    {
      name: 'Create Nature of Breach',
      value: 'postNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All Nature of Breach',
      value: 'viewAllNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View Nature of Breach',
      value: 'viewNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update Nature of Breach',
      value: 'patchNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete Nature of Breach',
      value: 'deleteNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate Nature of Breach',
      value: 'activateNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate Nature of Breach',
      value: 'deactivateNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete Nature of Breach',
      value: 'softDeleteNatureOfBreach',
      module: 'Master Data',
      default: false
    },
    // Sector
    {
      name: 'Create Sector',
      value: 'postSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All Sector',
      value: 'viewAllSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View Sector',
      value: 'viewSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update Sector',
      value: 'patchSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete Sector',
      value: 'deleteSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate Sector',
      value: 'activateSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate Sector',
      value: 'deactivateSector',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete Sector',
      value: 'softDeleteSector',
      module: 'Master Data',
      default: false
    },
    // Cause of Incident
    {
      name: 'Create Cause of Incident',
      value: 'postCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All Cause of Incident',
      value: 'viewAllCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View Cause of Incident',
      value: 'viewCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update Cause of Incident',
      value: 'patchCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete Cause of Incident',
      value: 'deleteCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate Cause of Incident',
      value: 'activateCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate Cause of Incident',
      value: 'deactivateCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete Cause of Incident',
      value: 'softDeleteCauseOfIncident',
      module: 'Master Data',
      default: false
    },
    // Record Type
    {
      name: 'Create Record Type',
      value: 'postRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View All Record Type',
      value: 'viewAllRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'View Record Type',
      value: 'viewRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Update Record Type',
      value: 'patchRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Delete Record Type',
      value: 'deleteRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Activate Record Type',
      value: 'activateRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Deactivate Record Type',
      value: 'deactivateRecordType',
      module: 'Master Data',
      default: false
    },
    {
      name: 'Soft Delete Record Type',
      value: 'softDeleteRecordType',
      module: 'Master Data',
      default: false
    },
    // ASIR
    {
      name: 'Create Annual Security Incident Report',
      value: 'postAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'View All Annual Security Incident Report',
      value: 'viewAllAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'View Annual Security Incident Report',
      value: 'viewAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'Update Annual Security Incident Report',
      value: 'patchAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'Delete Annual Security Incident Report',
      value: 'deleteAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'Activate Annual Security Incident Report',
      value: 'activateAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'Deactivate Annual Security Incident Report',
      value: 'deactivateAsir',
      module: 'Annual Security Incident Report',
      default: false
    },
    {
      name: 'Soft Delete Annual Security Incident Report',
      value: 'softDeleteAsir',
      module: 'Annual Security Incident Report'
    },
    {
      name: 'View All Deadline',
      value: 'viewAllDeadline',
      module: 'Annual Security Incident Report'
    },
    {
      name: 'View Deadline',
      value: 'viewDeadline',
      module: 'Annual Security Incident Report'
    },
    {
      name: 'Update Deadline',
      value: 'patchDeadline',
      module: 'Annual Security Incident Report'
    },
    // PDBNF
    {
      name: 'Create PDBNF',
      value: 'postPdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'View All PDBNF',
      value: 'viewAllPdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'View PDBNF',
      value: 'viewPdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Update PDBNF',
      value: 'patchPdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Delete PDBNF',
      value: 'deletePdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Activate PDBNF',
      value: 'activatePdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Deactivate PDBNF',
      value: 'deactivatePdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Soft Delete PDBNF',
      value: 'softDeletePdbnf',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Evaluate PDBNF',
      value: 'evaluatePdbnf',
      module: 'PDBNF',
      default: false
    },
    // FBNER
    {
      name: 'Create FBNER',
      value: 'postFbner',
      module: 'PDBNF'
    },
    {
      name: 'View All FBNER',
      value: 'viewAllFbner',
      module: 'FBNER'
    },
    {
      name: 'View FBNER',
      value: 'viewFbner',
      module: 'FBNER'
    },
    {
      name: 'Update FBNER',
      value: 'patchFbner',
      module: 'FBNER'
    },
    {
      name: 'Soft Delete FBNER',
      value: 'softDeleteFbner',
      module: 'FBNER'
    },
    // PBNEF
    {
      name: 'Create Pbnef',
      value: 'postPbnef',
      module: 'PBNEF',
      default: false
    },
    {
      name: 'View All Pbnefs',
      value: 'viewAllPbnef',
      module: 'PBNEF',
      default: false
    },
    {
      name: 'View Pbnef',
      value: 'viewPbnef',
      module: 'PBNEF',
      default: false
    },
    {
      name: 'Update Pbnef',
      value: 'patchPbnef',
      module: 'PBNEF',
      default: false
    },
    {
      name: 'Upload documents to PBNEF',
      value: 'pbnefDocUploading',
      module: 'PBNEF',
      default: false
    },
    {
      name: 'Download documents from PBNEF',
      value: 'pbnefDocDownloading',
      module: 'PBNEF',
      default: false
    },
    // SHOW CAUSE ORDER
    {
      name: 'Post Show Cause',
      value: 'postShowCause',
      module: 'Show Cause Order',
      default: false
    },
    {
      name: 'View Show Cause',
      value: 'viewShowCause',
      module: 'Show Cause Order',
      default: false
    },
    {
      name: 'Patch Show Cause',
      value: 'patchShowCause',
      module: 'Show Cause Order',
      default: false
    },
    // SHOW CAUSE SETTINGS
    {
      name: 'View Show Cause Settings',
      value: 'viewDaysSetting',
      module: 'PDBNF',
      default: false
    },
    {
      name: 'Patch Show Cause Settings',
      value: 'patchDaysSetting',
      module: 'PDBNF',
      default: false
    }
  ]
}
